import { render, staticRenderFns } from "./PlayerClientIdentityAdd.vue?vue&type=template&id=0913cafe&"
import script from "./PlayerClientIdentityAdd.vue?vue&type=script&lang=js&"
export * from "./PlayerClientIdentityAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports